import React from 'react';

import { Radio } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { RadioChecked, RadioUnchecked } from '../../icons';

export interface RadioButtonProps {
  checked?: boolean;
  disabled?: boolean;
  label?: React.ReactNode;
  testId?: string;
  value?: string | number;
  onChange?: (e?: any) => void;
}

export const RadioButton = (props: RadioButtonProps): JSX.Element => {
  const {
    onChange,
    checked,
    disabled,
    label = '',
    testId,
    value,
    ...rest
  } = props;
  return (
    <FormControlLabel
      control={
        <Radio
          checked={checked}
          checkedIcon={<RadioChecked size="s" />}
          color="default"
          data-fd={testId}
          disabled={disabled}
          icon={<RadioUnchecked size="s" />}
          value={value}
        />
      }
      onChange={onChange}
      value={value}
      label={label}
      labelPlacement="end"
      {...rest}
    />
  );
};
